import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { WorklogRoutingModule } from './worklog-routing.module';
import { WorklogComponent } from '../components/worklog/worklog.component';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { AddWorklogComponent } from '../components/add-budget/add-worklog.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';


@NgModule({
  declarations: [
    WorklogComponent,
    AddWorklogComponent
  ],
  imports: [
    CommonModule,
    WorklogRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    NgSelectModule,
    SharedComponentsModule,
    NgxMatTimepickerModule
  ]
})
export class WorklogModule { }
